import firebase from 'firebase/app';
import { useEffect, useState } from 'react';

import { Offer } from '../../models/offers.model';
import { firestore } from '../firebase';
import { FirestoreCollection } from '../firebase.models';

import { useProcessDates } from './useProcessDates.hook';

export function useGetOffer(id: string): [Offer, boolean, firebase.FirebaseError] {
  const [error, setError] = useState<firebase.FirebaseError>();
  const [loading, setLoading] = useState(false);
  const [offer, setOffer] = useState<Offer>();
  const [hasPermission, setHasPermission] = useState<boolean>(undefined);

  // useEffect #1: Sprawdź permission asynchronicznie
  useEffect(() => {
    firestore
      .collection(FirestoreCollection.OFFERS)
      .doc(id)
      .get()
      .then((snapshot) => {
        if (snapshot.exists) {
          console.log('DEBUG: User has permission to view this offer');
          setHasPermission(true);
        } else {
          // Document doesn't exist in OFFERS but user has access
          setHasPermission(true);
        }
      })
      .catch(() => {
        // Permission denied by Firestore rules
        console.log('DEBUG: No access to OFFERS collection, will use OFFERS_PUBLIC');
        setHasPermission(false);
      });
  }, [id]);

  // useEffect #2: Pobierz ofertę dopiero gdy hasPermission jest znane
  useEffect(() => {
    if (hasPermission === undefined) return; // Czekaj na wynik permission check

    setLoading(true);
    setError(null);

    const collection = hasPermission ? FirestoreCollection.OFFERS : FirestoreCollection.OFFERS_PUBLIC;

    const unsubscribe = firestore
      .collection(collection)
      .doc(id)
      .onSnapshot(
        (snapshot) => {
          const data = snapshot.data();
          setOffer(
            data
              ? ({
                  ...snapshot.data(),
                  id,
                  ...useProcessDates({
                    availability: data.availability,
                    availabilityTo: data.availabilityTo,
                    offerValidTo: data.offerValidTo,
                    createdAt: data.createdAt,
                    lastModified: data.lastModified,
                  }),
                } as Offer)
              : null
          );
          setLoading(false);
        },
        (e) => {
          console.log('Error', e);
          setError(e);
          setLoading(false);
        }
      );
    return () => unsubscribe();
  }, [id, hasPermission]);

  return [offer, loading, error];
}
